// extracted by mini-css-extract-plugin
export default {"modalText":"G175808"};